import './accordion.css';
import platnye1 from './platnye1.jpg';
import platnye2 from './platnye2.jpg';

const AccordionDataImages = [

    { 
      title: 'Платные услуги',
      description: "Платные услуги",
      images: [
        { src: platnye1, alt: 'Платные услуги' },
        { src: platnye2, alt: 'Платные услуги' },
      ]
    },
  ];
  
  export default AccordionDataImages;